import api from "@/assets/js/utils/api.js";
import {
  showSuccess,
  showError,
  showLoading,
  hideLoading,
  showCustom,
} from "@/assets/js/utils/alertService.js";

export default {
  name: "ResetPasswordView",
  data() {
    return {
      form: {
        email: "", //補上這行
        password: "",
        confirmPassword: "",
      },
      errors: {
        password: "",
        confirmPassword: "",
      },
      showPassword: false,
      showConfirmPassword: false,
      isSubmitting: false,
      resetSuccess: false,
      token: "", // 從URL獲取的重設密碼令牌
      passwordStrength: "weak", // weak, medium, strong
      strengthLabels: {
        weak: "弱",
        medium: "中等",
        strong: "強",
      },
    };
  },
  computed: {
    hasMinLength() {
      return this.form.password.length >= 8;
    },
    strengthScore() {
      return this.hasMinLength ? 100 : 0;
    },
    strengthText() {
      if (this.form.password.length === 0) return "無";
      return this.strengthScore < 100 ? "弱" : "強";
    },
    strengthClass() {
      if (this.form.password.length === 0) return "strength-none";
      return this.strengthScore < 100 ? "strength-weak" : "strength-strong";
    },
    strengthPercentage() {
      return this.strengthScore;
    },
    // 是否可以提交表單
    canSubmit() {
      return (
        this.form.password.length >= 8 &&
        this.form.password === this.form.confirmPassword
      );
    },
  },
  mounted() {
    // 從URL獲取重設密碼令牌
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    }, // 切換密碼顯示控制

    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    }, // 切換確認密碼顯示控制

    updatePasswordStrength() {
      const password = this.form.password;
      let strength = 0;

      // 長度檢查
      if (password.length >= 8) strength++;
      if (password.length >= 12) strength++;

      // 字符類型檢查
      if (/[a-z]/.test(password)) strength++;
      if (/[A-Z]/.test(password)) strength++;
      if (/[0-9]/.test(password)) strength++;
      if (/[^a-zA-Z0-9]/.test(password)) strength++;

      // 設定強度等級
      if (strength <= 2) {
        this.passwordStrength = "weak";
      } else if (strength <= 4) {
        this.passwordStrength = "medium";
      } else {
        this.passwordStrength = "strong";
      }
    },

    validateForm() {
      if (!this.form.password || this.form.password.length < 8) {
        showCustom("密碼太短", "請輸入至少 8 個字元的密碼", "warning"); // ✅ 使用AlertService
        return false;
      }

      if (this.form.password !== this.form.confirmPassword) {
        showCustom("密碼不一致", "請確認兩次輸入的密碼相同", "warning"); // ✅ 使用AlertService
        return false;
      }

      return true;
    }, // 表單驗證控制（弱點避免）

    async handleResetPassword() {
      if (!this.validateForm()) return; // ✅ 驗證表單 //控制表單驗證

      this.isSubmitting = true; // ✅ 設定提交狀態 //控制避免重複提交
      showLoading("處理中，請稍候..."); // ✅ 顯示讀取 //控制UI Loading

      try {
        // ✅ 自動從網址取 token //控制token注入
        const token = (this.$route.query.token || "").trim();

        const payload = {
          Token: token, // ✅ 自動帶入 URL token //控制後端資料
          NewPassword: this.form.password, // ✅ 新密碼 //控制後端資料
          ConfirmPassword: this.form.confirmPassword, // ✅ 確認密碼 //控制後端資料
        };

        const response = await api.post("/customer/reset-password", payload, {
          headers: {
            "Content-Type": "application/json",
          },
        }); // ✅ 呼叫後端 //控制API請求

        hideLoading(); // ✅ 隱藏讀取 //控制UI Loading

        if (response.status === 200) {
          this.resetSuccess = true; // ✅ 狀態更新 //控制狀態flag
          showSuccess("重設密碼成功！"); // ✅ 顯示成功UI //控制提示UI
        } else {
          showError(response.data?.message || "後端回傳非成功狀態"); // ✅ 顯示錯誤 //控制錯誤處理
        }
      } catch (error) {
        hideLoading(); // ✅ 隱藏Loading //控制UI Loading
        console.error("❌ 錯誤狀態碼：", error.response?.status); // ✅ Debug用 //控制錯誤資訊
        console.error("❌ 錯誤訊息：", error.response?.data); // ✅ Debug用 //控制錯誤資訊

        const msg =
          error.response?.data ||
          (error.response?.status === 401
            ? "重設密碼連結已過期或無效"
            : "伺服器錯誤，請稍後再試");

        showError(msg); // ✅ 顯示錯誤UI //控制錯誤提示
      } finally {
        this.isSubmitting = false; // ✅ 重置提交狀態 //控制避免重複提交
      }
    },

    goToLogin() {
      this.$router.push("/login"); // ✅ 返回登入頁
    }, // 導回登入流程控制
  },
};
